import { useSyncExternalStore } from 'react';
import { mealQueue, type QueuedMeal } from './queue';

const EMPTY: QueuedMeal[] = [];

let cache: QueuedMeal[] = mealQueue.list();

function getSnapshot(): QueuedMeal[] {
  return cache;
}

function subscribe(onChange: () => void): () => void {
  return mealQueue.subscribe((entries) => {
    // `useSyncExternalStore` compara por identidad: el snapshot se congela acá y no se recalcula
    // en cada render, o React entra en un bucle de "el store cambió durante el render".
    cache = entries;
    onChange();
  });
}

export function usePendingMeals(): QueuedMeal[] {
  return useSyncExternalStore(subscribe, getSnapshot, () => EMPTY);
}
